import {
  getIndustryDataAPI,
  getCaseTypeDataAPI,
  getGroupDataAPI,
  getDepartmentDataAPI,
  getPositionListDataAPI,
  getJobListDataAPI
} from '@/api/common'

// 公用
const commonModule = {
  namespaced: true,
  state() {
    return {
      industry: [],
      industryForm: [],
      casesType: [],
      casesTypeForm: [],
      group: [],
      groupForm: [],
      department: [],
      departmentForm: [],
      position: [],
      positionForm: [],
      job: [],
      jobForm: []
    }
  },
  mutations: {
    getIndustry(state, industry) {
      state.industryForm.splice(0,state.industryForm.length)
      state.industry.splice(0,state.industry.length)

      industry.forEach(item => {
        state.industry.push(item)
      })
      const res = industry.map(item => {
        return {
          label: item.name,
          value: item.name,
          key: item.id
        }
      })
      res.forEach(item => {
        const foundItem = state.industry.find(
          groupItem => groupItem.id === item.key
        )
        if (foundItem) {
          state.industryForm.push(item)
        }
      })
    },
    getCaseType(state, casesType) {
      state.casesTypeForm.splice(0,state.casesTypeForm.length)
      state.casesType.splice(0,state.casesType.length)
      casesType.forEach(item => {
        state.casesType.push(item)
      })
      const res = casesType.map(item => {
        return {
          label: item.name,
          value: item.id,
          key: item.id
        }
      })
      res.forEach(item => {
        const foundItem = state.casesType.find(
          groupItem => groupItem.id === item.key
        )
        if (foundItem) {
          state.casesTypeForm.push(item)
        }
      })
    },
    getGroup(state, group) {
      state.groupForm.splice(0,state.groupForm.length)
      state.group.splice(0,state.group.length)

      group.forEach(item => {
        state.group.push(item)
      })
      const res = group.map(item => {
        return {
          label: item.title,
          value: item.title,
          key: item.id
        }
      })
      res.forEach(item => {
        const foundItem = state.group.find(
          groupItem => groupItem.id === item.key
        )
        if (foundItem) {
          state.groupForm.push(item)
        }
      })
    },
    getDepartment(state, department) {
      state.departmentForm.splice(0,state.departmentForm.length)
      state.department.splice(0,state.department.length)
      department.forEach(item => {
        state.department.push(item)
      })
      const res = department.map(item => {
        return {
          label: item.title,
          value: item.title,
          key: item.id
        }
      })
      res.forEach(item => {
        const foundItem = state.department.find(
          departmentItem => departmentItem.id === item.key
        )
        if (foundItem) {
          state.departmentForm.push(item)
        }
      })
    },
    getPosition(state, position) {
      state.positionForm.splice(0,state.positionForm.length)
      state.position.splice(0,state.position.length)
      position.forEach(item => {
        state.position.push(item)
      })
      const res = position.map(item => {
        return {
          label: item.title,
          value: item.title,
          key: item.id
        }
      })
      res.forEach(item => {
        const foundItem = state.position.find(
          positionItem => positionItem.id === item.key
        )
        if (foundItem) {
          state.positionForm.push(item)
        }
      })
    },
    getJob(state, job) {
      state.jobForm.splice(0,state.jobForm.length)
      state.job.splice(0,state.job.length)
      job.forEach(item => {
        state.job.push(item)
      })
      const res = job.map(item => {
        return {
          label: item.title,
          value: item.title,
          key: item.id
        }
      })
      res.forEach(item => {
        const foundItem = state.job.find(
          jobItem => jobItem.id === item.key
        )
       
        if (foundItem) {
          state.jobForm.push(item)
        }
      })
    }
  },
  actions: {
    async asyncGetIndustry({ commit }) {
      const { data: res } = await getIndustryDataAPI()
      if (res.code !== 200) {
        return Promise.reject(new Error('获取数据失败！'))
      } else {
        commit('getIndustry', res.data)
      }
    },
    async asyncGetCaseType({ commit }) {
      const { data: res } = await getCaseTypeDataAPI()
      if (res.code !== 200) {
        return Promise.reject(new Error('获取数据失败！'))
      } else {
        commit('getCaseType', res.data)
      }
    },
    async asyncGetGroupType({ commit }) {
      const { data: res } = await getGroupDataAPI()
      if (res.code !== 200) {
        return Promise.reject(new Error('获取数据失败！'))
      } else {
        commit('getGroup', res.data)
      }
    },
    async asyncGetDepartmentData({ commit }) {
      const { data: res } = await getDepartmentDataAPI()
      if (res.code !== 200) {
        return Promise.reject(new Error('获取数据失败！'))
      } else {
        commit('getDepartment', res.data)
      }
    },
    async asyncGetPositionData({ commit }) {
      const { data: res } = await getPositionListDataAPI()
      if (res.code !== 200) {
        return Promise.reject(new Error('获取数据失败！'))
      } else {
        commit('getPosition', res.data)
      }
    },
    async asyncGetJobData({ commit }, pid) {
      const { data: res } = await getJobListDataAPI(pid)
      if (res.code !== 200) {
        return Promise.reject(new Error('获取数据失败！'))
      } else {
        commit('getJob', res.data)
      }
    }
  },
  getters: {}
}
export default commonModule
